import { apiRequest } from "./apiClient";

export const getAboutSliders = async () => {
 try {
  const data = await apiRequest("/about-sliders");
  return data.sliders?.length ? data.sliders : [];
 } catch (error) {
  return [];
 }
};
